var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/styles";
import { PickersCalendarHeader } from "@mui/x-date-pickers";
export const CustomDateCalendarHeader = (_a) => {
    var { hideArrows } = _a, rest = __rest(_a, ["hideArrows"]);
    const theme = useTheme();
    const styles = {
        ".MuiPickersArrowSwitcher-root": {
            visibility: hideArrows ? "hidden" : "visible",
        },
        ".MuiPickersCalendarHeader-label": {
            color: theme.palette.primary.main,
            fontWeight: 900,
        },
        ".MuiButtonBase-root.Mui-disabled.MuiIconButton-root.Mui-disabled": {
            visibility: "hidden",
        },
        ".MuiSvgIcon-root.MuiSvgIcon-fontSizeInherit.MuiSvgIcon-root": {
            color: theme.palette.primary.main,
        },
        ".MuiPickersCalendarHeader-switchViewIcon": {
            fill: theme.palette.primary.main,
        },
        ".MuiPickersFadeTransitionGroup-root, .MuiPickersCalendarHeader-labelContainer.MuiPickersCalendarHeader-labelContainer": {
            cursor: "default",
        },
    };
    return _jsx(PickersCalendarHeader, Object.assign({}, rest, { sx: styles }));
};
